import { IOrgsFilterState } from '../types/orgFilterState';
import { IAllOrganizationsQueryVariables } from '../types/types.generated';

export const initOrgState: IOrgsFilterState = {
  query: '',
  selectedService: '',
  selectedSourceSystem: '',
  offset: 0,
  limit: 20,
  sortDirection: 'asc',
  sortKey: 'name',
  filterApplied: false,
};

export const toAllOrgsQueryVars = (
  state: IOrgsFilterState
): IAllOrganizationsQueryVariables => {
  const {
    offset,
    limit,
    sortDirection,
    sortKey,
    query,
    selectedService,
    selectedSourceSystem,
  } = state;

  return {
    offset,
    limit,
    sortBy: `${sortDirection}(${sortKey})`,
    all: query ? `exists=${query}` : null,
    serviceIds: selectedService !== '' ? [selectedService] : null,
    queryKeyIds: selectedSourceSystem !== '' ? [selectedSourceSystem] : null,
  };
};
